export default {
  title: '船司账号维护',
  menuGroup: '运价管理',
  filter: {
    keyword: '搜索关键字',
    keywordPlaceholder: '搜索账号名称/船司名称',
    status: '账号状态',
    carrier: '船司/平台'
  },
  ui: {
    filterConfigName: '船司账号维护筛选配置',
    filterConfigRemark: '船司账号维护默认筛选配置'
  },
  columns: {
    accountName: '账号名称',
    companyName: '所属公司',
    carrierName: '船司/平台',
    loginAccount: '登录账号',
    status: '状态',
    enabled: '启用',
    lastVerified: '最近验证'
  },
  actions: {
    create: '新增账号',
    edit: '编辑',
    test: '测试',
    delete: '删除',
    batchTest: '批量测试',
    batchEnable: '批量启用',
    batchDisable: '批量停用',
    viewDetail: '查看详情',
    testConnection: '测试连接',
    close: '关闭'
  },
  form: {
    createTitle: '新增账号',
    editTitle: '编辑账号',
    accountName: '账号名称',
    accountNamePlaceholder: '请输入账号名称，如 MSC 主账号',
    company: '所属公司',
    companyPlaceholder: '请选择所属公司',
    carrier: '船司/平台',
    carrierPlaceholder: '请选择船司/平台',
    loginAccount: '登录账号',
    loginAccountPlaceholder: '请输入船司官网或平台的登录账号',
    password: '密码',
    passwordPlaceholder: '请输入密码',
    passwordEditPlaceholder: '请输入新密码（必须填写）',
    passwordEditTip: '编辑时必须重新输入密码',
    remark: '备注',
    remarkPlaceholder: '内部备注信息',
    enabled: '是否启用'
  },
  detail: {
    title: '账号详情',
    company: '所属公司',
    carrier: '船司/平台',
    loginAccount: '登录账号',
    password: '密码',
    status: '状态',
    enabled: '启用',
    lastVerified: '最近验证',
    createdBy: '创建人',
    createdAt: '创建时间',
    remark: '备注',
    tabVerification: '验证记录',
    viewSensitiveTitle: '查看敏感信息需要验证',
    viewSensitiveContent: '确认后将显示明文密码，10 秒后自动重新脱敏。该操作将被记录。',
    viewSensitiveFailed: '获取明文密码失败'
  },
  testDialog: {
    title: '连通性测试',
    testing: '测试中...',
    success: '连通成功',
    fail: '连通失败',
    summary: '测试完成：成功 {success} 个，失败 {fail} 个'
  },
  verification: {
    verifyTime: '验证时间',
    verifyMethod: '验证方式',
    result: '验证结果',
    responseTime: '响应时间',
    errorMessage: '错误信息',
    verifyBy: '操作人',
    filterResult: '验证结果',
    empty: '暂无验证记录，点击「测试连通性」开始测试'
  },
  confirm: {
    delete: '确定要删除该账号吗？删除后无法恢复',
    disable: '停用后，该账号将不再用于运价获取和报价执行，是否继续？',
    disableTitle: '确认停用',
    disableOk: '确认停用',
    batchDisable: '确定停用选中的 {count} 个账号？',
    batchDisableTitle: '批量停用'
  },
  message: {
    loadFailed: '加载账号列表失败，请重试',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败，请重试',
    deleteInUse: '删除失败，该账号可能正在使用中',
    enableSuccess: '已启用',
    disableSuccess: '已停用',
    operationFailed: '操作失败，请重试',
    saveSuccess: '账号保存成功',
    saveFailed: '保存失败，请重试',
    verifyFailed: '账号密码有误，请重新验证',
    testSuccess: '连接测试成功（响应时间: {time}ms）',
    testFailed: '连接测试失败：{message}',
    testRequestFailed: '测试请求失败，请重试',
    testDisabledTip: '账号已停用，请先启用后再进行连接测试',
    batchEnableSuccess: '已启用 {count} 个账号',
    batchDisableSuccess: '已停用 {count} 个账号',
    batchEnableFailed: '批量启用失败，请重试',
    batchDisableFailed: '批量停用失败，请重试',
    noPermission: '暂无访问权限',
    selectedCount: '已选择 {count} 项',
    carrierOptionsEmpty: '船司列表为空，请确认 MDM 基础数据服务可用',
    carrierOptionsLoadFailed: '船司列表加载失败，请稍后重试'
  },
  empty: {
    list: '暂无船司账号，点击新增账号开始配置',
    search: '未找到匹配的账号，请调整搜索条件'
  },
  validation: {
    accountNameRequired: '请输入账号名称',
    accountNameMaxLength: '账号名称不能超过100个字符',
    companyRequired: '请选择所属公司',
    carrierRequired: '请选择船司/平台',
    loginAccountRequired: '请填写登录账号',
    passwordRequired: '请填写登录密码'
  },
  enums: {
    status: {
      normal: '正常',
      verifyFailed: '验证失败',
      disabled: '停用'
    },
    verifyResult: {
      success: '成功',
      fail: '失败'
    },
    verifyMethod: {
      saveCheck: '保存校验',
      connectivityTest: '连通性测试',
      downstreamExecute: '下游执行'
    }
  },
  fixedCarriers: {
    CMA: '达飞轮船',
    MSC: '地中海航运',
    OOCL: '东方海外',
    ONE: '海洋网联',
    HPL: '赫伯罗特',
    MSK: '马士基航运',
    HMM: '现代商船',
    ZIM: '以星航运',
    EMC: '长荣海运',
    COSCO: '中远海运'
  },
  backendError: {
    carrierRequired: '船司不能为空',
    carrierCodeNotFound: '无法根据船司代码找到对应船司，请检查配置',
    connectivityTestFailed: '连接测试失败',
    verifyServiceUnavailable: '账号校验服务不可用，请检查运价获取服务配置',
    accountNameRequired: '账号名称不能为空',
    companyRequired: '所属公司不能为空',
    carrierPlatformRequired: '船司/平台不能为空',
    loginRequired: '登录账号不能为空',
    passwordRequired: '登录密码不能为空',
    enabledRequired: '启用状态不能为空',
    accountIdRequired: '账号ID不能为空',
    accountIdListRequired: '账号ID列表不能为空'
  }
}
